// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  dashboardApiBaseUrl : 'https://user-management-oauth-uat-twdwtabx5q-el.a.run.app',
  commonOnboardingApi : 'https://apidev.iserveu.online/commononboarding-report-ippb',
  showUsers : 'https://indshowuser-zwqcqy3qmq-uc.a.run.app/ind_showuser',
  showUsersParent : 'https://indshowuser-zwqcqy3qmq-uc.a.run.app/ind_showuser',
  showUsersType : 'staging',
  elasticsearchUserApiUrl : 'https://b61295e3bdc84097ac04e0456792cac1.us-central1.gcp.cloud.es.io:9243/ippb_users/_search',
  userManagementApiUrl : 'https://user-registration-uat-twdwtabx5q-el.a.run.app',
  mATMReportApiUrl : 'https://indmatmtxnreport-zwqcqy3qmq-uc.a.run.app',
  walletReportApiUrl : 'https://indmatmtxnreport-zwqcqy3qmq-uc.a.run.app',
  commissionReportApiUrl : 'https://indmatmtxnreport-zwqcqy3qmq-uc.a.run.app',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
